import { Component } from '@angular/core';

@Component({
  selector: 'app-kb-welcome',
  templateUrl: './kb-welcome.component.html',
  styleUrls: ['./kb-welcome.component.css']
})
export class KbWelcomeComponent {}
